// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZUNc","buttons":"styles_buttons__1muj2"};